//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import kayangAppSdk from '../../../js/kayang-app-sdk.js';
import nativeAdapter from '../../../js/nativeAdapter/nativeAdapter';

export default {
    name: 'head-bar',
    data() {
        return {
            needClose: nativeAdapter.closeWin,
            needScan: nativeAdapter.isKayang,
            arr: []
        }
    },
    methods: {
        onClickLeft: function () {
            this.arr = []
            if (this.needCloseWin && this.isHome) {
                this.closeWin()
            } else {
                const backurl = this.$route.query.backUrlVue;
                if (backurl) {
                    this.$router.push(backurl)
                } else {
                    this.$router.back()
                }
            }
        },
        onClickRight() {
            kayangAppSdk.scanQrCodeGo();
        },
        closeWin() {
            nativeAdapter.closeWin()
        },
        //跳转极光推送消息
        onClickAppMessageCenter() {
            this.$x.jumpApp('PortalMobile/AppMessageCenter.aspx')
        },
    },
    computed: {
        needBack() {
            return !this.$route.meta.noGoBack && this.canGoBack
        },
        isHome() {
            return this.$route.path === '/'
        },
        // 钉钉单点返回
        needCloseWin() {
            return nativeAdapter.isDingtalk // || nativeAdapter.isWechat
        },
        title() {
            const route = this.$route;
            if (route.query.customTitle) {
                return route.query.customTitle
            } else {
                var titles = [route.meta.title, route.query.title]
                return titles.filter(title => title).join(' - ')
            }
        },
        ...mapGetters(['scanCode', 'auroraPush', 'canGoBack'])
    },
};

